"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var spaui_utils_1 = require("@tencent/spaui-utils");

var spaui_1 = require("@tencent/spaui");

var info_1 = __importDefault(require("./info"));

var useDimensions_1 = __importDefault(require("./useDimensions"));

var SelectionSearchComponent = function SelectionSearchComponent(props) {
  var _a;

  var _b = props.placeholder,
      placeholder = _b === void 0 ? '' : _b,
      onChange = props.onChange,
      value = props.value,
      onClick = props.onClick,
      _c = props.classNameMap,
      classNameMap = _c === void 0 ? {} : _c,
      clear = props.clear,
      propsOnClear = props.onClear,
      onKeyDown = props.onKeyDown,
      addon = props.addon,
      style = props.style;

  var _d = __read((0, useDimensions_1["default"])(), 2),
      ref = _d[0],
      width = _d[1].width;

  var onClear;
  var hasClear = clear && value;
  var clearWdith = 32; // 如果是undefined的那就默认与onChange结合

  if (typeof propsOnClear === 'undefined') {
    onClear = function onClear(event) {
      if (onChange) {
        onChange(__assign(__assign({}, event), {
          target: {
            value: ''
          }
        }));
      }
    };
  } else {
    onClear = propsOnClear;
  }

  return react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-selection-search relative', classNameMap.SelectSearchClassName, {
      'has-clear': hasClear
    }),
    supportAllEvents: true
  }, SelectionSearchComponent), {
    style: __assign((_a = {}, _a['--search-addon-width'] = "".concat(width, "px"), _a), style)
  }), react_1["default"].createElement(spaui_1.Input, {
    onClick: onClick,
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    onKeyDown: onKeyDown,
    style: {
      paddingRight: "".concat(hasClear ? width + clearWdith : width, "px")
    }
  }), hasClear ? react_1["default"].createElement("div", {
    className: "spaui-input-clear",
    role: "button",
    onClick: onClear,
    style: {
      right: "".concat(width, "px")
    },
    "aria-label": "\u6E05\u9664"
  }, react_1["default"].createElement(spaui_1.Icon, {
    name: "clear-outlined"
  })) : null, addon ? react_1["default"].createElement("div", {
    className: "absolute right-0 top-0 bottom-0",
    ref: ref
  }, addon) : null);
};

(0, spaui_utils_1.setComponentMark)(SelectionSearchComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(SelectionSearchComponent);